import { render } from "./DownloadLayout.vue?vue&type=template&id=f8d7c9aa&scoped=true"
import script from "./DownloadLayout.vue?vue&type=script&lang=js"
export * from "./DownloadLayout.vue?vue&type=script&lang=js"

import "./DownloadLayout.vue?vue&type=style&index=0&id=f8d7c9aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d7c9aa"]])

export default __exports__